/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import SystemModulesMainContainer from './how-to-main/container/SystemModulesMainContainer';
import SystemModulesSubContainer from './how-to-sub/container/SystemModulesSubContainer';

function HowToContainer({ match, pathName }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/general-settings/how-to/main"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/how-to/main') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  How To Main
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/general-settings/how-to/sub"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/how-to/sub') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  How To Sub
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/main`} />}
          />
          <Route
            path={`${match.path}/main`}
            component={SystemModulesMainContainer}
          />
          <Route
            path={`${match.path}/sub`}
            component={SystemModulesSubContainer}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

HowToContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(HowToContainer);
